export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const WEBSOCKET_URL = import.meta.env.VITE_WEBSOCKET_URL;
export const LOGIN_URL = `${API_BASE_URL}/login`;
export const LOGOUT_URL = `${API_BASE_URL}/api/auth/logout`;
export const REFRESH_TOKEN_URL = `${API_BASE_URL}/api/auth/refresh-token`;
export const VERIFY_2FA_URL = `${API_BASE_URL}/api/auth/verify-2fa`;
export const VERIFY_RECOVERY_CODE_URL = `${API_BASE_URL}/api/auth/verify-recovery-code`;
export const SELECT_BRANCH_URL = `${API_BASE_URL}/api/auth/select-branch`;
